var PersonType;

(function (PersonType) {
  PersonType["Author"] = "AUTHOR";
  PersonType["Expert"] = "EXPERT";
})(PersonType || (PersonType = {}));

export { PersonType as PersonTypeDoctissimoFr };